import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import intlTelInput from "intl-tel-input";
import "intl-tel-input/build/css/intlTelInput.css";
import {
  clearFormData,
  createContactInquiry,
} from "../features/contactInquiry";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Contact = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [contactFormData, setContactFormData] = useState(null);
  const [errors, setErrors] = useState({});
  const inputRef = useRef(null);
  const itiRef = useRef(null);
  const { contactInquiryLoader, contactForm } = useSelector(
    (state) => state.contact
  );

  useEffect(() => {
    const input = inputRef.current;
    if (input) {
      itiRef.current = intlTelInput(input, {
        initialCountry: "om",
        separateDialCode: true,
        onlyCountries: ["om"],
        allowDropdown: false,
      });

      return () => {
        // Cleanup: destroy the intl-tel-input instance
        itiRef.current?.destroy();
      };
    }
    setContactFormData(contactForm);
  }, [contactInquiryLoader, contactForm]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // if (name !== 'mobile_no') {
    setContactFormData({
      ...contactFormData,
      [name]: value,
    });
    // }
    validateField(name, value); // Validate as the user types
  };

  const validateField = (name, value) => {
    let errorMessage = "";
    switch (name) {
      case "name":
        if (!value.trim()) errorMessage = "Name is required.";
        break;
      case "mobile_no":
        // // console.log("mobile_no changes called");
        if (itiRef.current) {
          // // console.log("mobile_no changes called IF");
          // Get the full phone number (including country code)
          // const fullNumber = itiRef.current.telInput.value;
          // const countryCode = itiRef.current.selectedCountryData.dialCode;
          // const finalNumber = countryCode + fullNumber;
          // // // console.log(finalNumber, 'finalNumber');
          // // Validate the phone number
          // if (isNaN(finalNumber)) {
          //     errorMessage = "Enter a valid phone number.";
          //     console.error('Invalid phone number');
          // }
          // setContactFormData((contactFormData) => ({ ...contactFormData, ['mobile_no']: finalNumber }));
        } else {
          if (!value.trim()) errorMessage = "Mobile No is required.";
        }
        break;
      case "email":
        if (!/\S+@\S+\.\S+/.test(value))
          errorMessage = "Enter a valid email address.";
        break;
      case "message":
        if (!value.trim()) errorMessage = "Message cannot be empty.";
        break;
      default:
        break;
    }

    setErrors((prev) => ({ ...prev, [name]: errorMessage }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // // console.log(itiRef.current, 'itiRef.current');
    // // console.log({ contactFormData });

    if (itiRef.current) {
      // Get the full phone number (including country code)
      const fullNumber = itiRef.current.telInput.value;
      const countryCode = itiRef.current.selectedCountryData.dialCode;
      const finalNumber = countryCode + fullNumber;
      // // console.log(finalNumber, 'finalNumber');

      // Validate the phone number
      if (isNaN(finalNumber) && finalNumber) {
        toast.error("Invalid phone number");
        console.error("Invalid phone number");
        return;
      }
      if (finalNumber.toString().length <= 4) {
        toast.error("Phone number is too short");
        console.error("Phone number is too short");
        return;
      }

      // Dispatch the form data with the full phone number
      const updatedFormData = {
        ...contactFormData,
        mobile_no: Number(finalNumber),
      };
      // // console.log('Form Data:', updatedFormData);
      const formErrors = {};
      Object.keys(updatedFormData).forEach((field) => {
        const value = updatedFormData[field] || "";
        // // console.log({ field, value });
        validateField(field, value);
        // if (!value.trim()) {
        //     formErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required.`;
        // }
      });

      setErrors(formErrors);
      // // console.log({ formErrors });
      // // console.log({ updatedFormData });
      dispatch(createContactInquiry(updatedFormData))
        .then((res) => {
          // // console.log(res, 'res');
          setContactFormData({
            name: "",
            email: "",
            mobile_no: null,
            message: "",
          });
        })
        .catch((err) => {
          // // console.log(err, 'err');
        });
    } else {
      //while using normal inputs
      // // console.log({ contactFormData });

      const formErrors = {};
      Object.keys(contactFormData).forEach((field) => {
        const value = contactFormData[field] || "";
        // // console.log({ field, value });
        validateField(field, value);
        if (!value.trim()) {
          formErrors[field] = `${
            field.charAt(0).toUpperCase() + field.slice(1)
          } is required.`;
        }
      });
      // // console.log({ formErrors });

      // // console.log({ errors });

      if (
        !(
          formErrors?.name ||
          formErrors?.mobile_no ||
          formErrors?.email ||
          formErrors?.message
        )
      ) {
        dispatch(createContactInquiry(contactFormData))
          .then((res) => {
            if (res) {
              toast.success(t("contactFormSubmitSuccessMsg"));
              setContactFormData(null);
              dispatch(
                clearFormData({
                  name: "",
                  email: "",
                  mobile_no: null,
                  message: "",
                })
              );
            } else {
              toast.error(t("contactFormSubmitFailMsg"));
            }
          })
          .catch((err) => {
            // // console.log(err, 'err');
          });
      }
    }
  };

  return (
    <section className="why-us contact mt-5" id="contact">
      <Container>
        <Row className="align-items-center mt-4">
          <Col md={12} lg={6}>
            <div className="why-us-image">
              <img
                src={require("../assets/images/con-men.png")}
                alt="img"
                className="img-fluid"
              />
            </div>
          </Col>
          <Col md={12} lg={6}>
            <div className="why-us-form">
              <div className="form-title text-center">
                <h4>{t("contactUs.title")}</h4>
              </div>
              <Form onSubmit={(e) => handleSubmit(e)} noValidate>
                <div className="form-group">
                  <Form.Control
                    type="text"
                    className={`contact-form-style ${
                      errors.name ? "is-invalid" : "is-valid"
                    }`}
                    placeholder={t("contactUs.form.name")}
                    id="name"
                    name="name"
                    onChange={handleInputChange}
                    value={contactFormData?.name || ""}
                    required
                  />
                  {errors.name && (
                    <div className="invalid-feedback">{errors.name}</div>
                  )}
                </div>
                <div className="form-group">
                  <Form.Control
                    type="number"
                    id="mobile_no"
                    className={`contact-form-style w-100 ${
                      errors.mobile_no ? "is-invalid" : "is-valid"
                    }`}
                    placeholder={t("contactUs.form.phoneNumber")}
                    name="mobile_no"
                    onChange={handleInputChange}
                    value={contactFormData?.mobile_no || ""}
                    required
                  />
                  <div
                    className={`invalid-feedback ${
                      errors.mobile_no ? "d-block" : ""
                    }`}
                  >
                    {errors.mobile_no}
                  </div>
                </div>
                <div className="form-group">
                  <Form.Control
                    type="email"
                    className={`contact-form-style ${
                      errors.email ? "is-invalid" : "is-valid"
                    }`}
                    placeholder={t("contactUs.form.email")}
                    id="email"
                    name="email"
                    onChange={handleInputChange}
                    value={contactFormData?.email || ""}
                    required
                  />
                  {errors.email && (
                    <div className="invalid-feedback">{errors.email}</div>
                  )}
                </div>
                                <div className="form-group">
                  <Form.Control
                    type="text"
                    className={`contact-form-style ${
                      errors.email ? "is-invalid" : "is-valid"
                    }`}
                    placeholder={t("contactUs.form.subject")}
                    id="subject"
                    name="subject"
                    onChange={handleInputChange}
                    value={contactFormData?.subject || ""}
                    required
                  />
                  {errors.email && (
                    <div className="invalid-feedback">{errors.subject}</div>
                  )}
                </div>

                <div className="form-group">
                  <Form.Control
                    as="textarea"
                    className={`contact-form-style ${
                      errors.message ? "is-invalid" : "is-valid"
                    }`}
                    placeholder={t("contactUs.form.message")}
                    id="message"
                    name="message"
                    onChange={handleInputChange}
                    value={contactFormData?.message || ""}
                    required
                  ></Form.Control>
                  {errors.message && (
                    <div className="invalid-feedback">{errors.message}</div>
                  )}
                </div>
                <div className="form-group contactform-btn">
                  <Button type="submit" className="btn h-btn">
                    {t("contactUs.form.submit")}
                  </Button>
                </div>
              </Form>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Contact;
